module.exports = __webpack_public_path__ + "img/normal-palette-thumb.e3c94bcc.png";